<script setup>
import integrationAPI from 'dashboard/api/wgpt/integrations';
import { useAlert } from 'dashboard/composables';
import Button from 'next/button/Button.vue';
import { ref, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRouter, useRoute } from 'vue-router';

defineProps({
  integration: {
    type: Object,
    required: true,
  },
});

const isSubmitting = ref(false);
const { t } = useI18n();
const router = useRouter();
const route = useRoute();

onMounted(() => {
  const { error, error_message: errorMessage } = route.query;
  if (error === 'true' && errorMessage) {
    useAlert(
      t('WGPT_INTEGRATIONS.ZID.CALLBACK_ERROR', { error: errorMessage })
    );
    router.replace({ query: {} });
  }
});

const handleAuth = async () => {
  try {
    isSubmitting.value = true;
    const { data } = await integrationAPI.connectZid();

    if (data.redirect_url) {
      window.location.href = data.redirect_url;
    }
  } catch (error) {
    useAlert(t('WGPT_INTEGRATIONS.ZID.CONNECTION_ERROR'));
  } finally {
    isSubmitting.value = false;
  }
};
</script>

<template>
  <div class="max-w-6xl mx-auto p-5">
    <div
      class="outline outline-n-container outline-1 bg-n-alpha-3 rounded-md shadow flex-grow overflow-auto p-4"
    >
      <div class="flex items-center justify-center">
        <div class="flex h-16 w-16 items-center justify-center">
          <img
            :src="`/dashboard/images/integrations/${integration.id}.png`"
            class="max-w-full rounded-md border border-n-weak shadow-sm block dark:hidden bg-n-alpha-3 dark:bg-n-alpha-2"
          />
          <img
            :src="`/dashboard/images/integrations/${integration.id}-dark.png`"
            class="max-w-full rounded-md border border-n-weak shadow-sm hidden dark:block bg-n-alpha-3 dark:bg-n-alpha-2"
          />
        </div>
        <div class="flex flex-col justify-center m-0 mx-4 flex-1">
          <h3 class="mb-1 text-xl font-medium text-n-slate-12">
            {{ integration.name }}
          </h3>
          <p class="text-n-slate-11 text-sm leading-6">
            {{ integration.description }}
          </p>
        </div>
        <div class="flex justify-center items-center mb-0 w-[15%]">
          <Button
            blue
            faded
            :label="t('WGPT_INTEGRATIONS.ZID.CONNECT')"
            icon="i-lucide-external-link"
            :is-loading="isSubmitting"
            @click="handleAuth"
          />
        </div>
      </div>
    </div>
  </div>
</template>
